;(function($, undefined){
    var rnn = window.rnn;

    function initCalendarDropdown() {
        var $addToCalToggle = $('#addtocal'),
            $addToCalLinks = $('#addtocal .addtocal-link');
        $addToCalToggle.hover(function() {
            $(this).children('.addtocal-menu-wrapper').toggle();
        });
        for(var i = 0; i < $addToCalLinks.length; i++) {
            $($addToCalLinks[i]).on('click', _calendarHandler);
        }
    }

    function _getHostName(url) {
        return (url.indexOf('://') !== -1) ? url.split('/')[2].split(':')[0] : url.split('/')[1];
    }

    function _showNotification(msg) {
        rnn.modules.notifications.error(msg);
    }

    function _calendarHandler() {
        var url = $(this).attr('link'),
            domain = _getHostName(url);
        if(!url)
            return;
        // try CORS if google calendar needs to be checked as well
        if(domain === 'www.google.com')
            return window.open(url, '_blank');
        _checkCalendarLink(url, function() {
            window.location.href = url;
        }, function() {
            _showNotification('This event has already occurred');
        });
    }

    // ajax to check url status before responding
    function _checkCalendarLink(url, success, error) {
        $.ajax({
            url: url,
            type: 'GET',
            statusCode: {
                404: error
            }
        })
        .done(function(res, sta, xhr) {
            if(xhr.status === 200) {
                return success();
            }
        });
    }

    rnn.modules.register("calendarDropdown", {
        init: initCalendarDropdown
    });

})(jQuery);
